module.exports = __webpack_public_path__ + "static/img/icon-close-button-original.3da13dd.png";